import { Spin } from 'antd';

export default function LoadingIndicator() {
  return (
    <div className="CenteredSpin">
      <Spin />
    </div>
  );
}
